/** 
    @description this function will return the value of the environment variable and if it is not found it will return the default value
    
    @param {string} envName - the name of the environment variable
    @param {string} defaultValue - the default value of the environment variable
    
    @return {string} - the value of the environment variable or the default value
 */
function getEnv(envName, defaultValue) {
	return process.env[envName] || defaultValue;
}

/** 
    @description this function will return the value of the environment variable and if it is not found it will give error and close process the application
    
    @param {string} envName - the name of the environment variable
    @param {string} [errorMsg = ${envName} is required] - the error message to be displayed if the environment variable is not found
    
    @return {never | string} - the value of the environment variable or give error
 */
function getRequiredEnv(envName, errorMsg = `${envName} is required`) {
	const env = getEnv(envName);
	if (!env) {
		throw new Error(errorMsg);
	}

	return env;
}

const allEnvs = {
	version: getRequiredEnv("REACT_APP_VERSION"),
	baseUrl: getRequiredEnv("REACT_APP_BASE_URL"),
	defaultCityPrefix: getRequiredEnv("REACT_APP_DEFAULT_CITY_PREFIX"),
	apiTimeout: getEnv("REACT_APP_API_TIMEOUT", 5000),
	mapComponentKey: getRequiredEnv("REACT_APP_MAP_COMPONENT_KEY"),
	mapApiKey: getRequiredEnv("REACT_APP_MAP_API_KEY"),
	storageBaseUrl: getRequiredEnv("REACT_APP_STORAGE_BASE_URL"),
	uploadTimeout: getEnv("REACT_APP_UPLOAD_TIMEOUT", 30000),
};

export default allEnvs;
